/* eslint-disable semi,semi-style */
import { env } from '@/util/env';
// http://view.didistatic.com/static/dcms/548313280_medium_1.png

let prefix = 'https://static';
let basePath;
if (env === 'pre') {
  prefix = 'https://static-pre';
}
if (env === 'dev' || env === 'test') {
  basePath = 'https://open-epower.intra.xiaojukeji.com';
}
export default [
  {
    title: '桩企运维',
    node: 'app',
    path: '/devops',
    exact: false,
    desc: '设备运维指标，监控、告警、诊断服务',
    res: basePath ? basePath + '/devops' : prefix + '.am.xiaojukeji.com/epower/epower-devops/view/index.html',
  },
  {
    title: '加盟商运维',
    node: 'app',
    path: '/devopsNew',
    exact: false,
    desc: '设备运维指标，监控、告警、诊断服务',
    res: prefix + '.am.xiaojukeji.com/epower/epower-devops/view/index.html',
  },
];
